import { Header } from '../../../components/common/Header';
import { TextArea } from '../../../components/common/TextArea';
import { TextInput } from '../../../components/common/TextInput';
import { Select, SelectOption } from '../../../components/common/Select/Select';
import { TabProps } from '../ExercisePage';
import styles from '../ExercisePage.module.css';

const PLATFORM_OPTIONS: SelectOption[] = [
  { value: 'SCRATCH', label: 'Scratch' },
  { value: 'MICROBIT', label: 'Micro:bit' },
];

export const DetailsTab: React.FC<TabProps> = ({ formik }) => {
  return (
    <div>
      <Header size={5} content="Algemene informatie" className={styles.stepsHeader} />
      <TextInput
        label="Naam"
        value={formik.values.name}
        onChange={val => formik.setFieldValue('name', val)}
        type="text"
        touched={formik.touched.name}
        error={formik.errors.name}
      />
      <TextArea
        label="Beschrijving"
        value={formik.values.description}
        onChange={val => formik.setFieldValue('description', val)}
        rows={6}
        maxLength={500}
        touched={formik.touched.description}
        error={formik.errors.description}
      />
      <Select label="Platform" value={formik.values.platform} onChange={val => formik.setFieldValue('platform', val)} options={PLATFORM_OPTIONS} />
    </div>
  );
};
